import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface AuthRedirectProps {
  children: React.ReactNode;
}

const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.auth.user);
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);

  useEffect(() => {
    // Nếu đã đăng nhập và chưa đồng bộ tài khoản, chuyển hướng đến trang đồng bộ
    if (isAuthenticated && user && user.sync_account === 0) {
      navigate('/sync-account');
    }
  }, [user, isAuthenticated, navigate]);

  return <>{children}</>;
};

export default AuthRedirect;
